import React, { useEffect } from "react";
import HeaderWrapper from "./header.style";
import logo from "../../assets/images/logos/Tawuniya-Logo.svg";
import stc from "../../assets/images/logos/stc-logo.svg";
import Tawuniyalogo from "../../assets/images/logos/Tawuniya-Logo_blue.svg";
import logoWhite from "../../assets/images/logos/logo-white.png";
import langIcon from "../../assets/images/icons/icon_language-icon.svg";
import rightArrow from "../../assets/images/icons/icon_arrow-right.svg";
import { withTranslation } from "react-i18next";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "../../helpers/utils";
import { useSelector } from "react-redux";

const Header = ({ i18n }) => {
  const { businessLine } = useSelector((state) => state.travel);

  const changeLanguageHandler = () => {
    let lang = "en";
    let direction = "ltr";
    if (i18n.language === "en") {
      lang = "ar";
      direction = "rtl";
    } else {
      lang = "en";
      direction = "ltr";
    }

    i18n.changeLanguage(lang);
    document.body.dir = direction;
    document.documentElement.lang = lang;
  };
  useEffect(() => {
    changeLanguageHandler();
  }, []);

  // REBRANDING COLORS
  // let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  // if (businessLine === BUSINESS_LINE_PATHS.STC)
  //   businessColor = BUSINESS_LINE_COLORS.STC;

  return (
    <HeaderWrapper>
      <header
        className={"page--header " + (i18n.language === "ar" ? "ar" : "")}
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >
        <div className="container">
          <div className="wrapper">
            {businessLine === BUSINESS_LINE_PATHS.DEFAULT && (
              <a className="logo" href="https://tawuniya.com.sa">
                <picture>
                  <source media="(max-width:576px)" srcSet={logo} />
                  <source media="(max-width:768px)" srcSet={logoWhite} />
                  <img src={logo} alt="tawuniya logo" />
                </picture>
              </a>
            )}
            {businessLine === BUSINESS_LINE_PATHS.STC && (
              <div>
                <img src={stc} alt="stc logo" />
              </div>
            )}
            <div className="title"></div>
            <div className="back-wrapper">
              <div className="lang" onClick={changeLanguageHandler}>
                <span>{i18n.language === "en" ? "العربية" : "English"}</span>
                <img src={langIcon} alt="" />
              </div>
              {businessLine === BUSINESS_LINE_PATHS.DEFAULT && (
                <a className="back" href="https://www.tawuniya.com">
                  <span>{i18n.t("BACK_TAWUNIYA")}</span>
                  <img src={rightArrow} alt="" />
                </a>
              )}
              {businessLine === BUSINESS_LINE_PATHS.STC && (
                <div className="back">
                  <span>{i18n.t("BROUGHT_TAWUNIYA")}</span>
                  <img src={Tawuniyalogo} alt="tawuniya logo" />
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </HeaderWrapper>
  );
};
export default withTranslation()(Header);
